import AlertSquareRoundedIcon from '../svg/alert-square-rounded.svg';
import ArrowLeftIcon from '../svg/arrow-left.svg';
import ArrowRightIcon from '../svg/arrow-right.svg';
import AttachmentIcon from '../svg/attachment.svg';
import CheckMarkIcon from '../svg/check-mark.svg';
import CheckSquareRoundedIcon from '../svg/check-square-rounded.svg';
import CheckIcon from '../svg/check.svg';
import ChevronDownIcon from '../svg/chevron-down.svg';
import ChevronLeft from '../svg/chevron-left.svg';
import ChevronRight from '../svg/chevron-right.svg';
import ChevronUpIcon from '../svg/chevron-up.svg';
import CircleCheckIcon from '../svg/circle-check.svg';
import CommentIcon from '../svg/comment.svg';
import CrossSquareRoundedIcon from '../svg/cross-square-rounded.svg';
import CrossIcon from '../svg/cross.svg';
import DiscountCheckIcon from '../svg/discount-check.svg';
import DotsVerticalIcon from '../svg/dots-vertical.svg';
import DotsIcon from '../svg/dots.svg';
import Error from '../svg/error.svg';
import HeartIcon from '../svg/heart.svg';
import InfoSquareRoundedIcon from '../svg/info-square-rounded.svg';
import ListIcon from '../svg/list.svg';
import MailUpIcon from '../svg/mail-up.svg';
import MenuIcon from '../svg/menu.svg';
import MinusIcon from '../svg/minus.svg';
import PlusIcon from '../svg/plus.svg';
import ReceiptIcon from '../svg/receipt.svg';
import SbpIcon from '../svg/sbp-logo.svg';
import SearchIcon from '../svg/search.svg';
import ShareIcon from '../svg/share.svg';
import ShieldCheckIcon from '../svg/shield-check.svg';
import SteamIcon from '../svg/steam.svg';
import TrashIcon from '../svg/trash.svg';
import UserCircleIcon from '../svg/user-circle.svg';
import WorldIcon from '../svg/world.svg';

export const mapComponentByName = {
  'alert-square-rounded': AlertSquareRoundedIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right': ArrowRightIcon,
  attachment: AttachmentIcon,
  check: CheckIcon,
  'check-mark': CheckMarkIcon,
  'check-square-rounded': CheckSquareRoundedIcon,
  'chevron-down': ChevronDownIcon,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-up': ChevronUpIcon,
  'circle-check': CircleCheckIcon,
  comment: CommentIcon,
  cross: CrossIcon,
  'cross-square-rounded': CrossSquareRoundedIcon,
  'dots-vertical': DotsVerticalIcon,
  dots: DotsIcon,
  error: Error,
  heart: HeartIcon,
  'info-square-rounded': InfoSquareRoundedIcon,
  list: ListIcon,
  'mail-up': MailUpIcon,
  menu: MenuIcon,
  minus: MinusIcon,
  plus: PlusIcon,
  receipt: ReceiptIcon,
  search: SearchIcon,
  share: ShareIcon,
  trash: TrashIcon,
  'shield-check': ShieldCheckIcon,
  'user-circle': UserCircleIcon,
  world: WorldIcon,
  sbp: SbpIcon,
  'discount-check': DiscountCheckIcon,
  steam: SteamIcon,
} as const;

export type IconName = keyof typeof mapComponentByName;
